<template lang="pug">
.options
  .backdrop
  .content
    .title {{ title }}
    img.ticket-image(v-if="imageSrc" :src="imageSrc" :alt="title")
    .message(v-else) Kein Bild verfuegbar.
    Button(color="gray" @click.native="close" center path="infoDialog.close.button").button
</template>

<script>
import Button from '@/components/Button.vue';

export default {
  components: {
    Button,
  },
  props: ['overlaydata'],
  computed: {
    imageSrc() {
      return this.overlaydata && this.overlaydata.imageSrc || '';
    },
    title() {
      return this.overlaydata && this.overlaydata.title || 'Public Restroom Ticket';
    },
  },
  methods: {
    close() {
      this.$store.commit('openOverlay', '');
    },
  },
};
</script>

<style lang="sass" scoped>
.options
  width: 100%
  height: 100vh
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  position: fixed
  max-width: 480px
  margin: 0 auto
  right: 0
  top: 0
  left: 0
  z-index: 3000

.backdrop
  background-color: rgba(0, 0, 0, .8)
  width: 100%
  height: 100vh
  position: absolute
  z-index: 6

.content
  z-index: 7
  background-color: #fff
  border-radius: 10px
  padding: 20px
  margin: 20px
  position: relative
  width: calc(100% - 40px)
  max-height: 100vh
  overflow: auto

.title
  font-size: 25px
  color: #1DB2D1
  text-align: center

.message
  text-align: center
  color: #454F63
  margin-top: 20px
  line-break: anywhere

.ticket-image
  display: block
  width: 100%
  max-width: 100vw
  max-height: 70vh
  margin-top: 20px
  object-fit: contain

.button
  margin-top: 20px
</style>
